import React from 'react'
import './services.css'
import {BiCheck} from 'react-icons/bi'

export default function Services() {
  return (
    <section id="services">
      <h5>What I Offer</h5>
      <h2>Services</h2>

      <div className="container service__container">
        <article className="service">
          <div className="service__head">
            <h3>UI/UX Design</h3>
          </div>

          <ul className="service__list">
            <li>
              <BiCheck className="service__list-icon" />
              <p>User Research</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Wireframing</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Prototyping</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Responsive Design</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Accessibility Design</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Collaboration and Communication</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Continuous Improvement</p>
            </li>
          </ul>
        </article>
        <article className="service">
          <div className="service__head">
            <h3>Web Development</h3>
          </div>

          <ul className="service__list">
            <li>
              <BiCheck className="service__list-icon" />
              <p>Web Application Development</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>E-Commerce Development</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Responsive Web Design</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Content Management Systems</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>API Development and Integration</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Website Maintenance and Support</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Seach Engine Optimization</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Custom Web Solutions</p>
            </li>
          </ul>
        </article>
        <article className="service">
          <div className="service__head">
            <h3>Web Utilities</h3>
          </div>

          <ul className="service__list">
            <li>
              <BiCheck className="service__list-icon" />
              <p>Works Well with Graphic Designers</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Translate Wireframe Designs into Working Code</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Troubleshooting, Fixing Bugs, annd Glitches</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Build In Functionality and Responsiveness</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Updating and Renovating Sites</p>
            </li>
          </ul>
        </article>
      </div>
    </section>
  )
}
